<div class="service-page">
  <div class="service-card">
    <h2>Udfør kontrol</h2>

    <div class="form-section">
      <app-dialog-input-title title="Kontrol udført af"></app-dialog-input-title>
      <input class="text-input"
             type="text"
             [(ngModel)]="equipmentService.serviceBy" />
    </div>

    <div class="form-section">
      <app-dialog-input-title title="Dato for kontrol" [required]="true"></app-dialog-input-title>
      <mat-form-field appearance="outline" class="full-width">
        <input matInput
               [matDatepicker]="serviceDatePicker"
               [(ngModel)]="equipmentService.serviceDate"
               name="serviceDate"
               readonly
               (click)="serviceDatePicker.open()" />
        <mat-datepicker-toggle matIconSuffix
                               [for]="serviceDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #serviceDatePicker></mat-datepicker>
      </mat-form-field>
    </div>

    <div class="form-section">
      <app-dialog-input-title title="Vælg farve"></app-dialog-input-title>

      <div class="color-palette">
        <div *ngFor="let c of serviceColorItems"
             class="color-dot"
             [style.backgroundColor]="c.id"
             [class.selected]="equipmentService.serviceColor === c.id"
             (click)="equipmentService.serviceColor = c.id"></div>
      </div>
    </div>

    <div class="form-section">
      <app-dialog-input-title title="Kontroltype"></app-dialog-input-title>

      <div class="control-types">
        <mat-checkbox [(ngModel)]="equipmentService.typeService">Service</mat-checkbox>
        <mat-checkbox [(ngModel)]="equipmentService.typeCalibration">Kalibrering</mat-checkbox>
        <mat-checkbox [(ngModel)]="equipmentService.typeRepair">Reparation</mat-checkbox>
        <mat-checkbox [(ngModel)]="equipmentService.typeVerification">Verifikation</mat-checkbox>
        <mat-checkbox [(ngModel)]="equipmentService.typeMalfunction">Defekt</mat-checkbox>
      </div>

      <div class="hint" *ngIf="controlTypeText">
        Valgt: {{ controlTypeText }}
      </div>
    </div>

    <div class="form-section">
      <app-dialog-input-title title="Kontrol bemærkning"></app-dialog-input-title>
      <input class="text-input"
                [(ngModel)]="equipmentService.serviceComment"/>
    </div>

    <button mat-flat-button
            color="primary"
            class="save-button"
            (click)="saveService()"
            [disabled]="isServiceSaveDisabled">
      Udfør kontrol
    </button>
  </div>
</div>
